import React, { useCallback } from 'react';
import { InputHelperText, InputProps, useInput } from 'react-admin';
import {
  Box,
  Chip,
  FormHelperText,
} from '@mui/material';

const ButtonGroupSelectInput = (props: InputProps & {
  choices: {
    id: string;
    name: string;
    icon?: React.ElementType;
  }[];
}) => {
  const {
    choices,
    helperText,
  } = props;
  const {
    field,
    fieldState: {
      isTouched,
      invalid,
      error,
    },
    formState: {
      isSubmitted,
    },
  } = useInput(props);
  const onChangeAnalysisType = field.onChange;

  const handleChange = useCallback((
    event: React.MouseEvent<HTMLDivElement>,
  ) => {
    const value = (event.currentTarget as HTMLElement).getAttribute('data-value');
    if (value) {
      onChangeAnalysisType(value);
    }
  }, [onChangeAnalysisType]);

  const renderHelperText = (helperText !== false && helperText !== undefined)
    || ((isTouched || isSubmitted) && invalid);

  return (
    <Box>
      <Box
        display="flex"
        flexWrap="wrap"
        gap={2}
      >
        {choices.map((choice, index) => (
          <Chip
            key={choice.id}
            data-value={choice.id}
            ref={index === 0 ? field.ref : undefined}
            icon={choice.icon && <choice.icon />}
            variant={choice.id === field.value ? 'filled' : 'outlined'}
            color={choice.id === field.value ? 'neutral' : 'default'}
            onClick={handleChange}
            disabled={field.disabled}
            label={choice.name}
          />
        ))}
      </Box>
      <FormHelperText>
        {renderHelperText && (
          <InputHelperText
            error={error?.message}
            helperText={helperText}
          />
        )}
      </FormHelperText>
    </Box>
  );
};

export default ButtonGroupSelectInput;
